<template>
  <div id="headerId" class="header-warpper" :class="routerName=='/index'?'header-warpper-index':'sticky-css'">
    <el-row class="elrowwidth">
      <!-- <el-col :span="2" class="head-height"></el-col> -->
      <!-- <el-col :span="2" class="head-height center-box"> -->
        <img
          v-if="routerName=='/index'&&!isscol"
          class="logo-class"
          @click="$router.push('/')"
          src="../../assets/images/19.png"
          alt=""
          srcset=""
        />
        <img
          v-else
          class="logo-class"
          @click="$router.push('/')"
          src="../../assets/images/38.png"
          alt=""
          srcset=""
        />
      <!-- </el-col> -->
      <el-col :span="22" class="head-height">
        <el-row>
          <el-col :span="22">
            <!-- 导航列表 -->
            <div class="menu-box-warpper">
              <ul class="menu-box">
                <li
                  v-for="item in menuList"
                  :key="item.id"
                  @mouseover="item.id === 1 ? (schoolLinks = true) : ''"
                  @mouseleave="schoolLinks = false"
                  :class="routerName == item.path ? 'active' : ''"
                  @click="routeLink(item)"
                >
                  <router-link :to="item.path">{{ item.name }}</router-link>
                  <i v-if="item.id == 1" class="el-icon-caret-bottom" :class="routerName=='/index'&&!isscol?'el-icon-act':''"></i>
                </li>
              </ul>
            </div>
          </el-col>
          <el-col :span="2">
            <button @click="tipsText" class="login-btn">登录体验</button>
          </el-col>
        </el-row>
      </el-col>
      <!-- <el-col :span="2" class="head-height"></el-col> -->
    </el-row>

    <div
      class="yiyueSchool-links"
      v-show="schoolLinks"
      @mouseover="schoolLinks = true"
      @mouseleave="schoolLinks = false"
    >
      <el-row>
        <el-col :span="2" class="zhanweiBox"></el-col>
        <el-col :span="20">
          <div class="yiyueSchool-links-main">
            <el-row :gutter="117" class="mt49">
              <el-col
                class="links-item"
                :span="6"
                v-for="item in links.slice(0, 4)"
                :key="item.id"
              >
                <div
                  class="yiyueSchool-links-main-font1 clearfix"
                  @click="tipsText"
                >
                  <div>
                    <img
                      class="yiyueSchool1 w25"
                      :src="item.imgurl"
                      alt=""
                      srcset=""
                    />
                    <img
                      class="yiyueSchool2 w25"
                      :src="item.imgurl2"
                      alt=""
                      srcset=""
                    />
                    <span>{{ item.text }}</span>
                  </div>
                  <div>详情 <i class="el-icon-arrow-right"></i></div>
                </div>

                <p class="yiyueSchool-links-main-font2">{{ item.text2 }}</p>
              </el-col>
            </el-row>

            <el-row :gutter="117" class="mt71">
              <el-col
                class="links-item"
                :span="6"
                v-for="item in links.slice(4, 8)"
                :key="item.id"
              >
                <div class="yiyueSchool-links-main-font1 clearfix">
                  <div>
                    <img
                      class="yiyueSchool1 w25"
                      :src="item.imgurl"
                      alt=""
                      srcset=""
                    />
                    <img
                      class="yiyueSchool2 w25"
                      :src="item.imgurl2"
                      alt=""
                      srcset=""
                    />
                    <span>{{ item.text }}</span>
                  </div>
                  <div>详情 <i class="el-icon-arrow-right"></i></div>
                </div>

                <p class="yiyueSchool-links-main-font2">{{ item.text2 }}</p>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :span="2" class="zhanweiBox"></el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      schoolLinks: false,
      menuList: [
        {
          name: "首页",
          path: "/index",
          id: 0,
        },
        {
          name: "店务系统",
          path: "/storeSystem",
          id: 1,
        },
        {
          name: "意约学堂",
          path: "/yiyueSchool",
          id: 2,
        },
        {
          name: "招商加盟",
          path: "/attract",
          id: 3,
        },
        {
          name: "行业资讯",
          path: "/formation",
          id: 4,
        },
        {
          name: "关于我们",
          path: "/troduction",
          id: 5,
        },
        {
          name: "帮助中心",
          path: "/help",
          id: 6,
        },
        {
          name: "下载中心",
          path: "/downCenter",
          id: 7,
        },
      ],

      links: [
        {
          imgurl: require("../../assets/images/topLink1.png"),
          imgurl2: require("../../assets/images/topLink1-2.png"),
          text: "收银管理",
          text2: "开单收银扫码支付，自动记账不必算账",
          linkUrl: "",
          id: 0,
        },
        {
          imgurl: require("../../assets/images/topLink2.png"),
          imgurl2: require("../../assets/images/topLink2-2.png"),
          text: "会员管理",
          text2: "系统沉淀会员资源，促活留存个性营销",
          linkUrl: "",
          id: 1,
        },
        {
          imgurl: require("../../assets/images/topLink3.png"),
          imgurl2: require("../../assets/images/topLink3-2.png"),
          text: "预约/排班",
          text2: "在线预约自动排班，服务满意工作有序",
          linkUrl: "",
          id: 2,
        },
        {
          imgurl: require("../../assets/images/topLink4.png"),
          imgurl2: require("../../assets/images/topLink4-2.png"),
          text: "员工管理",
          text2: "打造内驱服务团队，效率提升业绩倍增",
          linkUrl: "",
          id: 3,
        },
        {
          imgurl: require("../../assets/images/topLink5.png"),
          imgurl2: require("../../assets/images/topLink5-2.png"),
          text: "商品库存",
          text2: "疗程套餐灵活设置，库存补给智能提醒",
          linkUrl: "",
          id: 4,
        },
        {
          imgurl: require("../../assets/images/topLink6.png"),
          imgurl2: require("../../assets/images/topLink6-2.png"),
          text: "连锁管理",
          text2: "多门店统一管理，标准化快速扩张品牌",
          linkUrl: "",
          id: 5,
        },
        {
          imgurl: require("../../assets/images/topLink7.png"),
          imgurl2: require("../../assets/images/topLink7-2.png"),
          text: "报表管理",
          text2: "多维数据统计分析，支持决策避免风险",
          linkUrl: "",
          id: 6,
        },
        {
          imgurl: require("../../assets/images/topLink8.png"),
          imgurl2: require("../../assets/images/topLink8-2.png"),
          text: "美业小程序",
          text2: "小程序赋能新美业，流量变现高效转化",
          linkUrl: "",
          id: 7,
        },
      ],
      isscol:false,
      routerName:'',
    };
  },
  watch:{
	  $route(to,from){
      // console.log(from.path);//从哪来
      console.log(to.path,'routerName1');//到哪去
      this.routerName = to.path
    }
  },
  created(){
    console.log(this.$route,'routerName2');
    this.routerName = this.$route.path.indexOf('/index')>=0?'/index':this.$route.path
    console.log(this.routerName,'111')
  },
  mounted(){
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    // 移除滚动事件监听
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      // 处理滚动事件
      if(window.scrollY>0){
          this.isscol = true
      }else{
          this.isscol = false
      }
    },
    tipsText() {
      // this.$message('即将开通，尽请期待。');
      window.location.href = "https://mendian.51yiyue.cn/";
    },
    routeLink(val) {
      if (val.name == "行业资讯") {
        if (localStorage.getItem("ISdetails") !== null) {
          localStorage.clear();
          location.reload();
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.elrowwidth{
  width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
}
.header-warpper {
  width: 100%;
  height: 80px;
  position: relative;
  & .head-height {
    height: 80px;
  }
  & .logo-class {
    width: 166px;
    height: 43px;
  }
  & .center-box {
    display: flex;
    align-items: center;
  }
  & .menu-box-warpper {
    width: 100%;
    height: 100%;
    text-align: right;
    & .menu-box {
      height: 80px;
      text-align: left;
      margin-left: 82px;
      & li {
        display: inline-block;
        line-height: 80px;
        font-weight: 500;
        cursor: pointer;
        font-size: 14px;
        & > a {
          padding: 10px 6px;
          color: #000;
          font-weight: 500;
        }
      }
      & li:not(:first-child) {
        margin-left: 40px;
      }
    }
  }

  .login-btn {
    width: 100px;
    height: 36px;
    // line-height: 36px;
    background: #FF6701;
    border-radius: 6px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #FFFFFF;
    border: none;
    float: right;
    margin-top: 23px;
  }
}
.scolcss{
  position: fixed!important;
  background: #fff!important;
  z-index: 1;
}
.header-warpper-index{
  position: absolute!important;
  z-index: 2;
  & .menu-box-warpper {
    width: 100%;
    height: 100%;
    text-align: right;
    & .menu-box {
      height: 80px;
      text-align: left;
      margin-left: 82px;
      & li {
        display: inline-block;
        line-height: 80px;
        cursor: pointer;
        font-weight: 500;
        font-size: 14px;
        & > a {
          padding: 10px 6px;
          font-weight: 500;
          color: #fff!important;
        }
      }
      & li:not(:first-child) {
        margin-left: 40px;
      }
    }
  }
}
.el-icon-act{
  color: #fff;
}
.active a {
  color: #ff9141 !important;
  border-bottom: 3px solid #ff9141;
}
.yiyueSchool-links {
  width: 100%;
  cursor: pointer;
  height: 312px;
  position: absolute;
  top: 80px;
  left: 0;
  z-index: 99999;
  background: #fff;
  & > .yiyueSchool-links-main {
    width: calc(100% - 102px);
  }
}
.yiyueSchool-links-main-font1 {
  font-size: 18px;
  display: inline-block;
  width: 100%;
  height: 26px;
  & > div {
    width: 50%;
    float: left;
    line-height: 34px;
    & > img {
      float: left;
    }
    & > span {
      margin-left: 10px;
    }
  }
  & > div:nth-child(2) {
    line-height: 36px;
    font-size: 14px;
    line-height: 34px;
  }
}
.yiyueSchool-links-main-font2 {
  line-height: 14px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999;
  margin-top: 27px;
}
.zhanweiBox {
  height: 200px;
}
.mt49 {
  margin-top: 49px;
}
.mt71 {
  margin-top: 49px;
}
.w25 {
  width: 25px;
}
.links-item:hover .yiyueSchool-links-main-font1 {
  color: #ff9141;
  & .yiyueSchool1 {
    display: none;
  }
  & .yiyueSchool2 {
    display: block;
  }
}
.links-item:hover .yiyueSchool-links-main-font2 {
  color: #000;
}
.yiyueSchool2 {
  display: none;
}
.hoverIcon:hover.yiyueSchool-links {
  display: block !important;
}
.sticky-css{
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 3;
}
</style>